import React from 'react';
import { CommentOutlined } from '@ant-design/icons';
import { SmartFormIntentOption, Col, Row } from './style';
import ChatRenderText from '../Text';

interface SmartFormIntentOptionsProps {
  // eslint-disable-next-line no-unused-vars
  handleSelection: (_: { name: string }) => void;
  languageCode: string;
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    text: string;
    metadata: {
      intents: {
        id: number | string;
        name: string;
        title?: string;
        titleExtra?: string;
        description?: string;
      }[];
    };
  };
  showOptions: boolean;
}

const SmartFormIntentOptions = function ({
  handleSelection,
  languageCode,
  message,
  showOptions,
}: SmartFormIntentOptionsProps) {
  return (
    <Col xs={24} md={11}>
      <ChatRenderText note message={message} />
      {showOptions && message.metadata.intents.map((intent) => (
        <div key={intent.id.toString()}>
          {intent.titleExtra && (
            <Row>
              <ChatRenderText
                note
                message={{
                  type: message.type,
                  createdAt: message.createdAt,
                  i18n: intent.titleExtra,
                }}
              />
            </Row>
          )}
          <Col key={intent.id.toString()}>
            <SmartFormIntentOption
              id={intent.id.toString()}
              name={intent.title || intent.description}
              locale={languageCode}
              onClick={() => handleSelection(intent)}
              $highlighted={intent.id === 'expertFallback'}
              icon={intent.id === 'expertFallback' && (
                <CommentOutlined style={{ fontSize: '26px' }} />
              )}
            />
          </Col>
        </div>
      ))}
    </Col>
  );
};

export default SmartFormIntentOptions;
